module.exports = __webpack_public_path__ + "cf1241de748f997611c44b3bbee54e2a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/climbs/climb_2.png
// module id = 1796
// module chunks = 1